import type { BlockStackProps, TextProps } from '@shopify/polaris';
import type { IGI18NTextProps } from '~/presentation/common';

import { GI18NText } from '~/presentation/common';
import { BlockStack } from '@shopify/polaris';

export type GTextContentProps = {
  contents: {
    content: string;
    textProps?: Partial<TextProps>;
    transformers?: IGI18NTextProps['transformers'];
  }[];
  blockStackProps?: BlockStackProps;
};
export const GTextContents: React.FC<GTextContentProps> = (props) => {
  const contents = props.contents;
  const blockStackProps = props.blockStackProps ?? {
    gap: '0',
  };
  const contentMarkup = () => {
    return contents.map((content, index) => (
      <GI18NText as="p" key={index} {...content.textProps} transformers={content.transformers}>
        {content.content}
      </GI18NText>
    ));
  };
  return <BlockStack {...blockStackProps}>{contentMarkup()}</BlockStack>;
};
